import { getInclusion, getShapes } from "api";
import moment from "moment/moment";
import { success } from "toastr";

export const categoriTypes = [
  { value: 1, label: "HPHT" },
  { value: 2, label: "LPHT" },
  { value: 3, label: "REAL" },
  { value: 4, label: "JIRAM" },
];

export const status = [
  { value: "", label: "NONE" },
  { value: "true", label: "Accept" },
  { value: "false", label: "Reject" },
];

export const forwardStatus = [
  { value: "", label: "NONE" },
  { value: "f", label: "Forward" },
  { value: "p", label: "Pending" },
  { value: "r", label: "Reject" },
];

export const process = (() => {
  const processIds = [];

  for (let i = 1; i <= 10; i++) {
    processIds.push({
      value: i,
      label: i,
    });
  }
  return processIds;
})();

export const purity = [
  { value: "", label: "NONE" },
  { value: "1", label: "IF" },
  { value: "2", label: "VVS2" },
  { value: "3", label: "VVS1" },
  { value: "4", label: "VS2" },
  { value: "5", label: "VS1" },
  { value: "6", label: "SI2" },
  { value: "7", label: "SI1" },
  { value: "8", label: "I2" },
  { value: "9", label: "I1" },
];

export const color = (() => {
  const colorIds = [{ value: "", label: "NONE" }];
  let id = 1
  for (let i = 68; i <= 90; i++) {   
    colorIds.push({
      value: id,
      label: String.fromCharCode(i),
    });
    id++
  }
  return colorIds;
})();


export const cubeList = (() => {
  const cubeIds = [{ value: "", label: "NONE" }];

  for (let i = 1; i <= 200; i++) {
    cubeIds.push({
      value: i + "-" + moment().format("DDMMYYYY"),
      label: i + "-" + moment().format("DDMMYYYY"),
    });
  }
  return cubeIds;
})();
